import {EntityType, PropertyDefinition, PropertyDefinitionConfig} from '../types';

export const TEMPLATE_PROPERTY_BOOLEAN_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idPropertyDefinitionBooleanRepository',
	singular: 'Boolean Field',
};

export const TEMPLATE_PROPERTY_BOOLEAN_TEMPLATE_PROPERTIES: PropertyDefinition[] = [{
	id: 'idPropertyDefinitionBooleanTemplateTitleProperty',
	parentId: TEMPLATE_PROPERTY_BOOLEAN_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'label',
	label: 'Label',
	required: true,
	autoFocus: true,
}, {
	id: 'idPropertyDefinitionBooleanTemplateSlugProperty',
	parentId: TEMPLATE_PROPERTY_BOOLEAN_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'slug',
	label: 'Key',
	required: true,
	disabled: true,
}];
